import { VALIDATESIGNUP_FAIL, VALIDATESIGNUP_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const validateSignupReducer = (state = initialState, action) => {
	switch (action.type) {
		case VALIDATESIGNUP_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case VALIDATESIGNUP_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}
	return state;
};

export default validateSignupReducer;
